import React from "react";

import async from "../components/Async";

// import PodcastPage from "../views/PodcastPage";
// import CEPage from "../views/CEPage";
// import InformationPage from "../views/InformationPage";
// import OtherArticlePage from "../views/OtherArticlePage";
import NewProductsPageContent from "../views/NewProductsPageContent";
import PromotionsPageContent from "../views/PromotionsPageContent";
import FeaturedManufacturerPage from "../views/FeaturedManufacturerPage";


// ICONS
const ManageContentIcon = '/static/img/SvgIcons/manageContentMainIcon.svg';
const AdsIcon = '/static/img/SvgIcons/icons8-ad.svg';
const ManufacturerIcon = '/static/img/SvgIcons/manu.icon.svg';
const CriteriaIcon = '/static/img/SvgIcons/criteriaPage-red.svg';
const ProductIcon = '/static/img/SvgIcons/icons8-shopping-cart.svg';
const PromoIcon = '/static/img/SvgIcons/icons8-promo.svg';
const RedirectIcon = '/static/img/SvgIcons/icons8-redirect.svg';
const PlacementCheckerIcon = '/static/img/SvgIcons/placementChecker.svg';
const CategoryIcon = '/static/img/SvgIcons/categoryMainIcon.svg';
const FeaturedContentIcon = '/static/img/SvgIcons/featuredContentMainIcon.svg';
const TemplateIcon = '/static/img/SvgIcons/templatesMainIcon.svg';
const ReviewsIcon = '/static/img/SvgIcons/reviewsMainIcon.svg';
const SkuIcon = '/static/img/SvgIcons/skuMainIcon.svg';
const PopupIcon = '/static/img/SvgIcons/icons8-pop-up.svg';

// Guards
const AuthGuard = async(() => import("../components/AuthGuard"));

// Auth components
const SignIn = async(() => import("../pages/auth/SignIn"));
const SignUp = async(() => import("../pages/auth/SignUp"));
const ResetPassword = async(() => import("../pages/auth/ResetPassword"));
const Page404 = async(() => import("../pages/auth/Page404"));
const Page500 = async(() => import("../pages/auth/Page500"));

// NEW AUTH PAGES
const AuthLoginPage = async(() => import("../views/AuthenticationLogin/AuthLoginPage"));
const AuthDirectoryPage = async(() => import("../views/AuthenticationLogin/AuthDirectoryPage"));
const AuthResetPassword = async(() => import("../views/AuthenticationLogin/AuthResetPasswordPage"));


// NEW ADMIN PAGES
const AdminRolesPage = async(() => import("../views/Administration/AdminRolesPage"));
const AdminAccountPage = async(() => import("../views/Administration/AdminAccountPage"));
const AdminUsers = async(() => import("../views/Administration/ManageUsersPage.jsx"));

//This governs routes for the app. If a route is private, add it to the protected page routes object below and give it the guard:authGuard key value pair
//Anything that isn't login or reset password related will need to get put in that object. Eventually, we'll get rid of anything else and we'll have to login
//to make things work permanently.

//DPS - Dental Product Shopper Pages
const ManageContentPage = async(() => import("../views/ManageContentPage.jsx"));
const ManageAdsPage = async(() => import("../views/Ads/ManageAdsPage"));
const ManufacturerAdsPage = async(() => import("../views/Ads/ManufacturerAdsPage.jsx"));
const HomePageContent = async(() => import("../views/HomePageContent"));
const ProductCategoryPage = async(() => import("../views/ProductCategoryPage"));
// const AddAdvertisementsPage = async(() => import("../views/AddAdvertisementsPage"));
const ArticleTemplatePage = async(() => import("../views/ArticleTemplatePage"));
// const BlogsPage = async(() => import("../views/BlogsPage"));
// const CaseStudyPage = async(() => import("../views/CaseStudyPage"));
// const ResearchPage = async(() => import("../views/ResearchPage"));
// const MarketingMaterialsPage = async(() => import("../views/MarketingMaterialsPage"));
// const VideoMaterialPage = async(() => import("../views/VideoMaterialPage"));
const EditCategoriesPage = async(() => import("../views/EditCategoriesPage"));
const OnsiteSEOPage = async(() => import("../views/OnsiteSEOPage"));
const DistributorPage = async(() => import("../views/DistributorPage"));
const ManufacturersPage = async(() => import("../views/ManufacturersPage"));
const ProductsPage = async(() => import("../views/ProductsPage"));
const ReviewsPage = async(() => import("../views/Reviews/ReviewsPage"));
const PromotionsPage = async(() => import("../views/PromotionsPage"));
// const EvaluationsPage = async(() => import("../views/EvaluationsPage"));
const CriteriaPage = async(() => import("../views/CriteriaPage"));
const PublishedOutlierPage = async(() => import("../views/PublishedOutlierPage"));
const SkusPage = async(() => import("../views/SkusPage"));
const PlacementCheckerPage = async(() => import("../views/PlacementCheckerPage"));
// const SitemapPage = async(() => import("../views/SitemapPage"));
const IpUploadPage = async(() => import("../views/IpUploadPage"));
const EmbedFormPage = async(() => import("../views/EmbedFormPage"));
const Page301Redirects = async(() => import("../views/Page301Redirects"));
const FeaturedRecentArticlesPage = async(() => import("../views/FeaturedRecentArticlesPage"));
const FeaturedCategoryContentPage = async(() => import("../views/FeaturedCategoryContentPage"));
const FeaturedNewsfeedPage = async(() => import("../views/FeaturedNewsfeedPage"));
const DynamicPersonasPage = async(() => import("../views/DynamicPersonasPage"))
const TeamMembersPage = async(() => import("../views/TeamMembersPage"))
const EvaluationCertificatesByProduct = async(() => import("../views/EvaluationSampleCertificates/EvaluationCertificatesByProduct"))
const EvaluationCertificates = async(() => import("../views/EvaluationSampleCertificates/EvaluationCertificates"))
const FeaturedPopUpPage = async(() => import("../views/FeaturedPopUpPage"))
const BuyersGuidePage = async(() => import("../views/BuyersGuidePage"));
const BuyersGuidePDFView = async(() => import("../views/BuyersGuide/BuyersGuidePDFView"));
const BuyersGuideDropBoxView = async(() => import("../views/BuyersGuide/BuyersGuideDropBoxView"))
const BuyersGuideOldContentView = async(() => import("../views/BuyersGuide/BuyersGuideOldContentView"))
const BuyersGuideNewProductView = async(() => import("../views/BuyersGuide/BuyersGuideNewProductView"))
const BuyersGuideReviewView = async(() => import("../views/BuyersGuide/BuyersGuideReviewView"))
const BuyersGuideClientEmailsView = async(() => import("../views/BuyersGuide/BuyersGuideClientEmailsView"))
const BuyersGuideFinalReviewView = async(() => import("../views/BuyersGuide/BuyersGuideFinalReviewView"))
const BuyersGuideImageExportView = async(() => import("../views/BuyersGuide/BuyersGuideImageExport"))


// NEW PAGES - STAND ALONE DL CMS
const BlogsListPage = async(() => import("../views/BlogsListPage.jsx"));
const CaseStudyListPage = async(() => import("../views/CaseStudyListPage.jsx"));
const ResearchListPage = async(() => import("../views/ResearchListPage.jsx"));
const MarketingMaterialsListPage = async(() => import("../views/MarketingMaterialsListPage.jsx"));
const ProductVideosListPage = async(() => import("../views/ProductVideosListPage.jsx"));
const PodcastListPage = async(() => import("../views/PodcastListPage.jsx"));
const CEListPage = async(() => import("../views/CEListPage.jsx"));
const InformationListPage = async(() => import("../views/InformationListPage.jsx"));
const OtherArticlesListPage = async(() => import("../views/OtherArticlesListPage.jsx"));
const EvaluationListPage = async(() => import("../views/EvaluationListPage.jsx"));
const ReportsPage = async(() => import("../views/ReportsPage.jsx"));
const FeaturedContentPage = async(() => import("../views/FeaturedContentPage"));
const ToolsPage = async(() => import("../views/ToolsPage"));

// DPS - dental product shopper page LAYOUTS

const FeaturedContentRoutes = {
    id: "Featured Content",
    basePath: '/featured-content',
    path: "/featured-content",
    icon: null,
    guard: AuthGuard,
    accessParam: 'featuredContent',
    children: [
        {
            path: "/featured-content",
            name: "Featured Content",
            component: FeaturedContentPage,
            guard: AuthGuard,
            isBasePath: true
        },
        {
            path: "/featured-content/home-page",
            name: "Home Page",
            component: HomePageContent,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/product-category-page",
            name: "Product Category Page",
            component: ProductCategoryPage,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/featured-manufacturer-page",
            name: "Manufacturer Page",
            component: FeaturedManufacturerPage,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/new-product-page",
            name: "New Product Page",
            component: NewProductsPageContent,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/promotions-page",
            name: "Promotion Listing Page",
            component: PromotionsPageContent,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/featured-recent-articles",
            name: "Recent Articles",
            component: FeaturedRecentArticlesPage,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/featured-category-content",
            name: "Category Page Content",
            component: FeaturedCategoryContentPage,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/featured-newsfeed",
            name: "Newsfeed",
            component: FeaturedNewsfeedPage,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/featured-popup",
            name: "Pop-ups",
            component: FeaturedPopUpPage,
            guard: AuthGuard,
        },
        {
            path: "/featured-content/embed-forms",
            name: "Embed Forms",
            component: EmbedFormPage,
            guard: AuthGuard,
            accessParam: 'embedForms',
        },
    ],
    component: null,
};

// const dashboardsRoutes = {
//     id: "Featured Content",
//     basePath: '/featured-content/',
//     path: "/featured-content/home-page",
//     icon: FeaturedContentIcon,
//     // containsHome: true,
//     guard: AuthGuard,
//     accessParam: 'featuredContent',
//     children: [
//         {
//             path: "/featured-content/home-page",
//             name: "Home Page",
//             component: HomePageContent,
//             guard: AuthGuard,
//         },
//         {
//             path: "/featured-content/product-category-page",
//             name: "Product Category Page",
//             component: ProductCategoryPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/featured-content/featured-manufacturer-page",
//             name: "Manufacturer Page",
//             component: FeaturedManufacturerPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/featured-content/promotions-page",
//             name: "New Product Page",
//             component: NewProductsPageContent,
//             guard: AuthGuard,
//         },
//         {
//             path: "/featured-content/new-product-page",
//             name: "Promotion Listing Page",
//             component: PromotionsPageContent,
//             guard: AuthGuard,
//         },
//         {
//             path: "/featured-content/featured-recent-articles",
//             name: "Recent Articles",
//             component: FeaturedRecentArticlesPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/featured-content/featured-category-content",
//             name: "Category Page Content",
//             component: FeaturedCategoryContentPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/featured-content/featured-newsfeed",
//             name: "Newsfeed",
//             component: FeaturedNewsfeedPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/featured-content/featured-popup",
//             name: "Pop-ups",
//             component: FeaturedPopUpPage,
//             guard: AuthGuard,
//         },
//     ],
//     component: null,
// };

// const FeaturedPopUp = {
//     id: "Pop Ups",
//     path: "/featured-content/featured-popup",
//     component: FeaturedPopUpPage,
//     icon: PopupIcon,
//     guard: AuthGuard,
//     accessParam: 'featuredContent',
//     children: null,
// };


const ManageContent = {
    id: "Manage Content",
    path: "/onsite-content",
    basePath: '/onsite-content',
    component: ManageContentPage,
    icon: ManageContentIcon,
    guard: AuthGuard,
    children: [
        {
            path: "/onsite-content",
            name: "Manage Content",
            component: ManageContentPage,
            guard: AuthGuard,
            isBasePath: true
        },
        {
            path: "/onsite-content/blogs",
            name: "Blogs",
            component: BlogsListPage,
            guard: AuthGuard,
        },
        {
            path: "/onsite-content/case-study",
            name: "Case Study",
            component: CaseStudyListPage,
            guard: AuthGuard,
        },
        {
            path: "/onsite-content/research",
            name: "Research",
            component: ResearchListPage,
            guard: AuthGuard,
        },
        {
            path: "/onsite-content/marketing-materials",
            name: "Marketing Materials",
            component: MarketingMaterialsListPage,
            guard: AuthGuard,
        },
        {
            path: "/onsite-content/videos",
            name: "Product Videos",
            component: ProductVideosListPage,
            guard: AuthGuard,
        },
        // {
        //     path: "/onsite-content/podcasts",
        //     name: "Podcasts",
        //     component: PodcastListPage,
        //     guard: AuthGuard,
        // },
        {
            path: "/onsite-content/ce",
            name: "Continuing Education",
            component: CEListPage,
            guard: AuthGuard,
        },
        {
            path: "/onsite-content/information",
            name: "Information",
            component: InformationListPage,
            guard: AuthGuard,
        },
        {
            path: "/onsite-content/other",
            name: "Other Articles",
            component: OtherArticlesListPage,
            guard: AuthGuard,
        },
        {
            path: "/onsite-content/evaluations",
            name: "Evaluations",
            component: EvaluationListPage,
            guard: AuthGuard,
            accessParam: 'evaluations',
        },
        {
            path: "/onsite-content/template",
            name: "Templates",
            component: ArticleTemplatePage,
            guard: AuthGuard,
            accessParam: 'blogsAndArticles',
        },
        {
            path: "/onsite-content/categories",
            name: "Categories",
            component: EditCategoriesPage,
            guard: AuthGuard,
            accessParam: 'editCategories',
        },
        {
            path: "/onsite-content/manufacturers",
            name: "Manufacturers",
            component: ManufacturersPage,
            guard: AuthGuard,
            accessParam: 'manufacturers',
        },
        {
            path: "/onsite-content/products",
            name: "Products",
            component: ProductsPage,
            guard: AuthGuard,
            accessParam: 'products',
        },
        {
            path: "/onsite-content/promotions",
            name: "Promotions",
            component: PromotionsPage,
            guard: AuthGuard,
            accessParam: 'promotions',
        },
        {
            path: "/onsite-content/reviews",
            name: "Reviews",
            component: ReviewsPage,
            guard: AuthGuard,
            accessParam: 'reviews',
        },
    ],
};



const AdPlacementRoutes = {
    id: "Ads",
    path: "/manage-ads-page",
    header: "Website Services",
    component: ManageAdsPage,
    icon: AdsIcon,
    guard: AuthGuard,
    accessParam: 'adPlacement',
    tabs: [
        {
            path: "/manage-ads-page",
            tab: "manufacturer",
            name: "Ads by Manufacturer",
            guard: AuthGuard,
        },
        {
            path: "/manage-ads-page",
            tab: "all",
            name: "All Ads List",
            guard: AuthGuard,
        },
    ],
};



const ToolsRouteDL = {
    id: "Tools / Other",
    basePath: '/tools',
    path: "/tools",
    icon: null,
    guard: AuthGuard,
    children: [
        {
            path: "/tools",
            name: "Tools / Other",
            component: ToolsPage,
            guard: AuthGuard,
            isBasePath: true
        },
        {
            path: "/tools/reports-export",
            name: "Reports",
            component: ReportsPage,
            guard: AuthGuard,
        },        
        {
            path: "/tools/placement-checker",
            name: "Placement Checker",
            component: PlacementCheckerPage,
            guard: AuthGuard,
            accessParam: 'placementChecker',
        },        
        {
            path: "/tools/criteria",
            name: "Criterion",
            component: CriteriaPage,
            guard: AuthGuard,
            accessParam: 'criterion',
        },        
        {
            path: "/tools/product-skus",
            name: "Edit Product Skus",
            component: SkusPage,
            guard: AuthGuard,
            accessParam: 'editProductSkus',
        },        
        {
            path: "/tools/ip-upload",
            name: "Ip Upload",
            component: IpUploadPage,
            guard: AuthGuard,
        },        
        {
            path: "/tools/redirects",
            name: "Redirects",
            component: Page301Redirects,
            guard: AuthGuard,
            accessParam: 'redirects',
        },        
        {
            path: "/tools/onsite-seo",
            name: "Onsite SEO",
            component: OnsiteSEOPage,
            guard: AuthGuard,
            accessParam: 'onsiteSEO',
        },        
        {
            path: "/tools/distributor",
            name: "Distributors",
            component: DistributorPage,
            guard: AuthGuard,
            accessParam: 'distributor',
        },        
        {
            path: "/tools/published-outlier-page",
            name: "Published Outlier Page",
            component: PublishedOutlierPage,
            guard: AuthGuard,
            accessParam: 'publishedOutlier',
        },        
        {
            path: "/tools/dynamic-personas",
            name: "Dynamic Personas",
            component: DynamicPersonasPage,
            guard: AuthGuard,
        },        
        {
            path: "/tools/ims-team-members",
            name: "Team Members",
            component: TeamMembersPage,
            guard: AuthGuard,
        },        
        {
            path: "/tools/evaluation-certificates",
            name: "Evaluation Certificates",
            component: EvaluationCertificatesByProduct,
            guard: AuthGuard,
        },        
    ],
    component: null,
};


const EvaluationCertificatesRoutes = {
    id: "ManufacturerAds",
    path: "/tools/evaluation-certificates/:productName",
    component: EvaluationCertificates,
    guard: AuthGuard,
};

// const ReviewsRoutes = {
//     id: "Reviews",
//     icon: ReviewsIcon,
//     path: "/reviews",
//     children: null,
//     component: ReviewsPage,
//     guard: AuthGuard,
//     accessParam: 'reviews',
// };

// const ReportsPag = {
//     id: "Reports",
//     path: "/reports-export",
//     children: null,
//     icon: <Grid />,
//     component: ReportsPage,
//     guard: AuthGuard,
// };

const ReviewsRoutes = {
    id: "Reviews",
    path: "/reviews",
    // header: "Website Services",
    component: ReviewsPage,
    icon: ReviewsIcon,
    guard: AuthGuard,
    accessParam: 'reviews',
    tabs: [
        {
            path: "/reviews",
            tab: "manufacturers",
            name: "Manufacturer Reviews",
            guard: AuthGuard,
        },
        {
            path: "/reviews",
            tab: "products",
            name: "Product Reviews",
            guard: AuthGuard,
        },
    ],
};

// const PlacementCheckerRoutes = {
//     id: "Placement Checker",
//     path: "/placement-checker",
//     // header: "Website Services",
//     component: PlacementCheckerPage,
//     children: null,
//     icon: PlacementCheckerIcon,
//     guard: AuthGuard,
//     accessParam: 'placementChecker',
// };

// const EditCategoriesPageRoutes = {
//     id: "Categories",
//     path: "/edit-categories",
//     header: "Other Resources",
//     component: EditCategoriesPage,
//     children: null,
//     icon: CategoryIcon,
//     guard: AuthGuard,
//     accessParam: 'editCategories',
// };

// const SitemapPageRoute = {
//     id: "Sitemaps",
//     path: "/sitemaps",
//     component: SitemapPage,
//     children: null,
//     icon: null,
//     guard: AuthGuard,
//     accessParam: 'sitemaps',
// };

// const IpUploadPageRoute = {
//     id: "Ip Upload",
//     path: "/ip-upload",
//     component: IpUploadPage,
//     children: null,
//     icon: null,
//     guard: AuthGuard,
//     // accessParam: 'ip-upload',
//     accessParam: '',
// };


// const Page301RedirectsRoute = {
//     id: "301 Redirects",
//     path: "/redirects",
//     component: Page301Redirects,
//     children: null,
//     icon: RedirectIcon,
//     guard: AuthGuard,
//     accessParam: 'redirects',
//     tabs: [
//         {
//             path: "/redirects",
//             tab: "redirect-301",
//             name: "301 Redirects",
//             guard: AuthGuard,
//         },
//         {
//             path: "/redirects",
//             tab: "redirect-404",
//             name: "404 URL Table",
//             guard: AuthGuard,
//         },
//     ],
// };

// const OnsiteSEOPageRoutes = {
//     id: "Onsite SEO",
//     path: "/onsite-seo",
//     component: OnsiteSEOPage,
//     children: null,
//     icon: null,
//     guard: AuthGuard,
//     accessParam: 'onsiteSEO',
//     tabs: [
//         {
//             path: "/onsite-seo",
//             tab: "onsite-seo-title-tags",
//             name: "Title Tags",
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-seo",
//             tab: "onsite-seo-meta-tags",
//             name: "Meta Tags",
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-seo",
//             tab: "onsite-seo-schema-markups",
//             name: "Schema Markups",
//             guard: AuthGuard,
//         },
//     ],
// }

// const DistributorPageRoutes = {
//     id: "Distributors",
//     path: "/distributor",
//     component: DistributorPage,
//     children: null,
//     icon: null,
//     guard: AuthGuard,
//     accessParam: 'distributor',
// }

// const EmbedFormRoutes = {
//     id: "Embed Forms",
//     path: "/embed-form",
//     component: EmbedFormPage,
//     children: null,
//     icon: null,
//     guard: AuthGuard,
//     accessParam: 'embedForms',
// }

// const PublishedOutlierPageRoutes = {
//     id: "Published Outlier Page",
//     path: "/published-outlier-page",
//     header: "Miscellaneous",
//     component: PublishedOutlierPage,
//     children: null,
//     icon: null,
//     guard: AuthGuard,
//     accessParam: 'publishedOutlier',
// };


// Not used at the moment
// const AddAdvertisementsRoutes = {
//     id: "Add Advertisement",
//     path: "/add-advertisement",
//     component: AddAdvertisementsPage,
//     children: null,
//     // icon: null,
//     guard: AuthGuard,
// };

const ManufacturerAdsRoutes = {
    id: "ManufacturerAds",
    path: "/manage-ads-page/:id",
    component: ManufacturerAdsPage,
    guard: AuthGuard,
    accessParam: 'adPlacement',
};

// const ManufacturersRoutes = {
//     id: "Manufacturers",
//     icon: ManufacturerIcon,
//     path: "/manufacturers",
//     header: "Manage Onsite Data",
//     children: null,
//     component: ManufacturersPage,
//     guard: AuthGuard,
//     accessParam: 'manufacturers',
// };

// const CriteriaRoutes = {
//     id: "Criterion",
//     icon: CriteriaIcon,
//     path: "/criteria",
//     children: null,
//     component: CriteriaPage,
//     guard: AuthGuard,
//     accessParam: 'criterion',
// };

// const SkusRoutes = {
//     id: "Edit Product Skus",
//     icon: SkuIcon,
//     path: "/product-skus",
//     children: null,
//     component: SkusPage,
//     guard: AuthGuard,
//     accessParam: 'editProductSkus',
// };

// const EvaluationRoutesOld = {
//     id: "Evaluations",
//     icon: <Activity />,
//     path: "/evaluations-old",
//     children: null,
//     component: EvaluationsPage,
//     guard: AuthGuard,
//     accessParam: 'evaluations',
// };

// const EvaluationRoutes = {
//     id: "Evaluations",
//     icon: <Activity />,
//     path: "/evaluations",
//     children: null,
//     component: EvaluationListPage,
//     guard: AuthGuard,
//     accessParam: 'evaluations',
// };

// const ProductsRoutes = {
//     id: "Products",
//     icon: ProductIcon,
//     path: "/products",
//     children: null,
//     component: ProductsPage,
//     guard: AuthGuard,
//     accessParam: 'products',
// };

// const PromotionsRoutes = {
//     id: "Promotions",
//     icon: PromoIcon,
//     path: "/promotions",
//     children: null,
//     component: PromotionsPage,
//     guard: AuthGuard,
//     accessParam: 'promotions',
// };

// const ReviewsRoutes = {
//     id: "Reviews",
//     icon: ReviewsIcon,
//     path: "/reviews",
//     children: null,
//     component: ReviewsPage,
//     guard: AuthGuard,
//     accessParam: 'reviews',
// };

// const BackRoute = {
//   id: "Back to CMS",
//   icon: <ArrowBack />,
//   path: "/",
// }

// const ArticleTemplateRoute = {
//     id: "Templates",
//     path: "/onsite-content/template",
//     icon: TemplateIcon,
//     children: null,
//     component: ArticleTemplatePage,
//     accessParam: 'blogsAndArticles',
//     guard: AuthGuard,
// }

// const OnsiteContentRoutes = {
//     id: "Blogs And Articles",
//     path: "/onsite-content",
//     header: "Manage Onsite Content",
//     component: ManageAdsPage,
//     icon: <BookOpen />,
//     guard: AuthGuard,
//     accessParam: 'blogsAndArticles',
//     children: [
//         {
//             path: "/onsite-content/blogs",
//             name: "Blogs",
//             component: BlogsListPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-content/case-study",
//             name: "Case Study",
//             component: CaseStudyListPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-content/research",
//             name: "Research",
//             component: ResearchListPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-content/marketing-materials",
//             name: "Marketing Materials",
//             component: MarketingMaterialsListPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-content/videos",
//             name: "Product Videos",
//             component: ProductVideosListPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-content/podcasts",
//             name: "Podcasts",
//             component: PodcastListPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-content/ce",
//             name: "Continuing Education",
//             component: CEListPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-content/information",
//             name: "Information",
//             component: InformationListPage,
//             guard: AuthGuard,
//         },
//         {
//             path: "/onsite-content/other",
//             name: "Other Articles",
//             component: OtherArticlesListPage,
//             guard: AuthGuard,
//         },
//     ],
// };

const authRoutes = {
    id: "Auth",
    path: "/auth",
    icon: null,
    children: [
        {
            path: "/",
            name: "Sign In",
            // component: SignIn,
            component: AuthLoginPage,
        },
        {
            path: "/auth/directory",
            name: "Sign In",
            component: AuthDirectoryPage,
        },
        {
            path: "/auth/sign-up",
            name: "Sign Up",
            component: SignUp,
        },
        {
            path: "/auth/reset-password",
            name: "Reset Password",
            // component: ResetPassword,
            component: AuthResetPassword,
        },
        {
            path: "/auth/404",
            name: "404 Page",
            component: Page404,
        },
        {
            path: "/auth/500",
            name: "500 Page",
            component: Page500,
        },
    ],
    component: null,
};





const adminRoutes = {
    id: "Administration",
    path: "/admin",
    icon: null,
    guard: AuthGuard,
    accessParam: 'siteAdmin',
    children: [
        {
            path: "/admin/users",
            name: "Manage Users",
            component: AdminUsers,
            guard: AuthGuard,
            accessParam: 'addUsers',
        },
        {
            path: "/admin/roles",
            name: "Manage Roles",
            component: AdminRolesPage,
            guard: AuthGuard,
            accessParam: 'manageRoles',
        },
        {
            path: "/admin/profile",
            name: "Profile",
            component: AdminAccountPage,
            guard: AuthGuard,
        },
    ],
    component: null,
};







// Buyers Guide Routes

const BuyersGuide = {
    id: "Buyers Guide",
    icon: null,
    path: "/buyers-guide",
    children: null,
    component: BuyersGuidePage,
    guard: AuthGuard,
    accessParam: 'buyersGuide',
};

const BuyersGuidePDF = {
    id: "PDF Upload",
    icon: null,
    path: "/buyers-guide/pdf-upload",
    children: null,
    component: BuyersGuidePDFView,
    guard: AuthGuard,
};

const BuyersGuideImageReview = {
    id: "Dropbox Image Review",
    path: "/buyers-guide/image-review",
    children: null,
    component: BuyersGuideDropBoxView,
    guard: AuthGuard,
};

const BuyersGuideInitialReview = {
    id: "Old Content Review",
    path: "/buyers-guide/initial-review",
    children: null,
    component: BuyersGuideOldContentView,
    guard: AuthGuard,
};

const BuyersGuideNewContent = {
    id: "Add New Content",
    path: "/buyers-guide/new-content",
    children: null,
    component: BuyersGuideNewProductView,
    guard: AuthGuard,

};

const BuyersGuideReview = {
    id: "Pre Client Review",
    path: "/buyers-guide/review",
    children: null,
    component: BuyersGuideReviewView,
    guard: AuthGuard,

};

const BuyersGuideEmailPrep = {
    id: "Client Email Prep",
    path: "/buyers-guide/email-prep",
    children: null,
    component: BuyersGuidePDFView,
    guard: AuthGuard,

};

const BuyersGuideClientActivity = {
    id: "Client Activity",
    path: "/buyers-guide/client-activity",
    children: null,
    component: BuyersGuideClientEmailsView,
    guard: AuthGuard,

};

const BuyersGuideFinal = {
    id: "Final Review",
    path: "/buyers-guide/final-review",
    children: null,
    component: BuyersGuideFinalReviewView,
    guard: AuthGuard,

};

const BuyersGuideImageExport = {
    id: "Image Export",
    path: "/buyers-guide/image-export",
    children: null,
    component: BuyersGuideImageExportView,
    guard: AuthGuard,

};

// const DynamicPersonasRoute = {
//     id: "Dynamic Personas",
//     path: "/dynamic-personas",
//     children: null,
//     component: DynamicPersonasPage,
//     guard: AuthGuard,
//     icon: null,

// };

// const TeamMembersRoute = {
//     id: "Team Members",
//     path: "/ims-team-members",
//     children: null,
//     component: TeamMembersPage,
//     guard: AuthGuard,
//     icon: null,

// };





// Routes using the Auth layout
export const authLayoutRoutes = [authRoutes, adminRoutes];

// Routes that are protected
export const protectedRoutes = [
    AdPlacementRoutes,
    FeaturedContentRoutes,
    ManageContent,
    ManufacturerAdsRoutes,
    // ReviewsRoutes,
    
    //Buyers Guide Routes
    BuyersGuide,

    ToolsRouteDL,
    EvaluationCertificatesRoutes,
    // ReportsPag,
    // dashboardsRoutes,
    // adminRoutes,
    // AddAdvertisementsRoutes,
    // ArticleTemplateRoute,
    // OnsiteContentRoutes,
    // EvaluationRoutesOld,
    // EditCategoriesPageRoutes,
    // PublishedOutlierPageRoutes,
    // ManufacturersRoutes,
    // ProductsRoutes,
    // PromotionsRoutes,
    // FeaturedPopUp,
    // CriteriaRoutes,
    // SkusRoutes,
    // EvaluationRoutes,
    // OnsiteSEOPageRoutes,
    // DistributorPageRoutes,
    // PlacementCheckerRoutes,
    // SitemapPageRoute,
    // IpUploadPageRoute,
    // EmbedFormRoutes,
    // Page301RedirectsRoute,
    // DynamicPersonasRoute,
    // TeamMembersRoute,
   
];

export const buyersGuideRoutes = [
    BuyersGuidePDF,
    BuyersGuideImageReview,
    // BuyersGuideInitialReview,
    BuyersGuideNewContent,
    BuyersGuideReview,
    BuyersGuideClientActivity,
    BuyersGuideFinal,
    BuyersGuideImageExport,
]

export const buyersGuideSidebarRoutes = [
    BuyersGuidePDF,
    BuyersGuideImageReview,
    // BuyersGuideInitialReview,
    BuyersGuideNewContent,
    BuyersGuideReview,
    BuyersGuideClientActivity,
    BuyersGuideFinal,
    BuyersGuideImageExport,
]

// Routes visible in the sidebar
export const sidebarRoutes = [
    ManageContent,
    FeaturedContentRoutes,
    AdPlacementRoutes,
    BuyersGuide,
    ToolsRouteDL,

    // dashboardsRoutes,
    // ReportsPag,
    // ManufacturersRoutes,
    // ProductsRoutes,
    // EditCategoriesPageRoutes,
    // PromotionsRoutes,
    // FeaturedPopUp,
    // PlacementCheckerRoutes,
    // OnsiteContentRoutes,
    // EvaluationRoutes,
    // ArticleTemplateRoute,
    // ReviewsRoutes,
    // CriteriaRoutes,
    // SkusRoutes,
    // SitemapPageRoute,
    // IpUploadPageRoute,
    // EmbedFormRoutes,
    // Page301RedirectsRoute,
    // OnsiteSEOPageRoutes,
    // DistributorPageRoutes,
    // PublishedOutlierPageRoutes,
    // DynamicPersonasRoute,
    // TeamMembersRoute,
];





// DPS Article Template Routes
// export const templateSidebar = [
//   BackRoute,
//   ArticleTemplateRoute
// ]